import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  title: string;
  closeButtonText?: string;
  open: boolean;
  onClose: () => void;
};

export const InfoModal: FC<PropsWithChildren<Props>> = ({
  title,
  open,
  onClose,
  closeButtonText,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {children}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{closeButtonText || t('modal.close')}</Button>
      </DialogActions>
    </Dialog>
  );
};
